var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_354_29852"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_354_29852)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,15L21,18L24,18L24,20L21,20L21,23L19,23L19,20L16,20L16,18L19,18L19,15L21,15ZM21.008,3C21.556,3,22,3.445,22,3.993L22,13.342C21.3576,13.1151,20.6813,12.99944,20,13L20,5L4,5L4.0009999999999994,19L13.293,9.707C13.6488,9.35002,14.2148,9.31401,14.613,9.623000000000001L14.706,9.708L18.252,13.258C14.9815,14.2546,13.2025,17.7775,14.342,21.001L2.992,21C2.443972,20.9994,1.999999880791,20.555,2,20.007L2,3.993C2.00380802,3.446556,2.44556,3.00435829,2.992,3L21.008,3ZM8,7C9.104569999999999,7,10,7.89543,10,9C10,10.104569999999999,9.104569999999999,11,8,11C6.89543,11,6,10.104569999999999,6,9C6,7.89543,6.89543,7,8,7Z",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomUpload);
export default __webpack_public_path__ + "static/media/custom_upload.ec749be332b2d78af6e944d43ffee9aa.svg";
export { ForwardRef as ReactComponent };